export class BroadcasterEventEntry {
  constructor(public eventId: number, public status: number) {}

  static fromObject(entry: any): BroadcasterEventEntry {
    return new BroadcasterEventEntry(
      entry.eventId,
      entry.status,
    )
  }
}